<template>
    <div class="product">
        <van-swipe :autoplay="3000" class="productImage">
            <van-swipe-item v-for="(image, index) in images" :key="index">
                <img v-lazy="image" />
            </van-swipe-item>
        </van-swipe>
        <van-panel :title="productPrice|currency" :desc="name" class="productInfoPanel">
            <div class="productDesc">
                <van-row type="flex" justify="center" align="center">
                    <van-col span="24" align="left" class="payResultText">商品包含:</van-col>
                </van-row>
                <van-row v-for="(d, index) in description" :key="index" type="flex" justify="center" align="center">
                    <van-col span="24" align="left" class="payResultTips">{{d}}</van-col>
                </van-row>
            </div>

            <div slot="footer">                
                <van-submit-bar
                v-show="orderTime"
                button-text="预约购买"
                @submit="onSubmit1"
                class="order"
                :disabled="btnDisabled"
                >
                
                <!-- <span slot="tip">
                    您的收货地址不支持同城送
                </span> -->
                <span slot="default">
                    <van-field type="tel" placeholder="请输入手机号码" class="mobileInput" v-model="phone" />
                </span>
                </van-submit-bar> 
                <div @click="onSubmit2" class="goButtonContainer" v-show="goTime"  >
                    <div class="goButton">
                        <van-submit-bar
                                    
                        button-text="购买"
                        class="go"
                        >                
                        <div slot="default" class="van-submit-bar_left">
                            <span class="buyLabel">支付：</span>
                            <span class="buyPrice">{{buyPrice|currency}}</span>
                        </div>
                        </van-submit-bar> 
                    </div>
                </div>                               
            </div>
        </van-panel>
        <van-panel  :title="''" class="voucherListPanel" v-show="goTime">
            <div class="voucherList">
                <van-checkbox-group v-model="vChecked">
                    <van-cell-group>
                        <van-cell
                        v-for="(item,index) in vlist"
                        clickable
                        :key="item.id"
                        
                        @click="toggle(index)"
                        >
                            <div slot="title" class="vName">
                                <span>套餐预约定金</span><span class="vPrice">{{item.amount/100|currency}}</span>
                                <span class="vStatus">可使用</span>
                            </div>
                            
                            <van-checkbox :name="item.name" ref="vouchers" disabled/>
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </div>
        </van-panel>
        <img src="static_niunai/img/icon_sit.png" class="icon_sit">
    </div>
</template>
<script>
import Vue from 'vue';
import click_handler from "../tools/mgtv/click";
import { page_view, click_event, casherPV } from "../tools/mgtv/analysis";
import { Lazyload,Swipe, SwipeItem,Panel, Row, Col,Field,SubmitBar,Toast,Cell,CellGroup,Checkbox,CheckboxGroup} from 'vant';
import {getCurrTime,getCouponList} from '../api/getData'
import orderAndPay from '../api/pay'
import {productId_order,productId_go,order_begin,order_end,go_begin,go_end,productPrice_order,productPrice_go, OrderProduct, GoProduct} from '../constant/products'
import {isIphone, isIpad, isWeiXin, isApp, isAndroid, isOTT, getInvoker, getPlatform,isSupportsWebP} from '../tools/mgtv/env'
import { login, logout } from "../tools/mgtv/login";
Vue.use(Swipe).use(SwipeItem).use(Lazyload).use(Panel).use(Row).use(Col).use(Field).use(SubmitBar).use(Toast).use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup);
import {mapState, mapActions} from 'vuex'
import {
ACT_P_ORDER,
ACT_ORDER,
ACT_E_ORDER,
ACT_P_GO,
ACT_GO,
ACT_E_GO
} from '../constant/act_stat'
export default {
  data() {
    return {     
        now:'',   
        images: [
        'static_niunai/img/d-1.jpg',
        'static_niunai/img/d-2.jpg',
        'static_niunai/img/d-3.jpg',
        'static_niunai/img/d-4.jpg',
        'static_niunai/img/d-5.jpg'        
        ],
        openid:"",
        channel:"",
        address:"",
        phone:"",
        receiverName:"",
        voucherid:"",
        returnUrl:"",
        vlist:[],//{id:"1",name:"voucher",title:"牛奶盒子预约定金",amount:20,checked:true}
        vChecked:[],
        btnDisabled:true
    }
  },
  watch: {
      phone(curVal,oldVal){
          if(/^1\d{10}$/.test(curVal))
            {   
                this.btnDisabled = false
            }
            else
            {    
                this.btnDisabled = true
            }
      },
      product(newVal,oldVal){
          console.log("watch product",newVal)
          if(newVal)
            this.initPage()
      }
  },
  computed: {
        ...mapState([
            'actInfo',
            'userInfo',
            'deviceInfo',
            'urlParams',
            'ticket',
            'voucher',
            'product'
        ]),
    orderTime: function() {
      return this.$store.getters.orderTime
    },
    goTime: function() {
      return this.$store.getters.goTime
    },
      productPrice:function(){
          return this.product.price;
      }
      ,
      buyPrice:function(){
          let buyPrice = this.productPrice
          if(this.vlist.length>0){
            buyPrice = this.productPrice - this.vlist[0].amount/100
          }          
          console.log("getBuyPrice：",buyPrice)
          return buyPrice;
      }
      ,
      name:function(){
          return this.product.name;
      },
      description:function(){
          return this.product.description;
      }
  },
  beforeMount(){
    console.log("OrderDetail beforeMount")
  },
  mounted () {
    console.log("OrderDetail mounted")
    history.pushState(null,null,`/usercenter/niunai.html`)
    page_view('详情页',this);
    casherPV(this);//支付上报
    console.log("OrderDetail document.URL",document.URL)
    this.initPage();
  }
  ,
  methods:{
    ...mapActions([
        'getVoucher'
    ]),
    initPage(){
        this.getCoupon()
    },
    pay_success(){
      this.$router.push({
        path: `/PaySuccess`,
        query: this.$route.query
      })
    },
    getCoupon(){
        let T = this;
        // getCouponList(T.ticket,T.product.id).then(res=>{
        //     if(res.err==0){
        //         if(res.data.length>0){
        //             let element = res.data[0]
        //             let item = {}
        //             item.id= element.id
        //             item.name = item.id
        //             item.title = element.des
        //             item.amount = element.amount
        //             item.checked = true
        //             T.vlist.push(item)
        //             T.vChecked.push(item.name)
        //             window.$bus.voucherid= item.id
        //             return
        //         }
        //     }
        //     else{
        //         Toast("代金券获取失败，请稍后再试")
        //     }
        // })
        if(T.product){
            console.log("getCoupon T.product",T.product)
            console.log("getCoupon T.product.id",T.product.id)        
            this.getVoucher({ticket:T.ticket,productId:T.product.id}).then(()=>{
                let item = this.voucher
                if(item.id){
                    T.vlist.push(item)
                    T.vChecked.push(item.name)
                }
            })
        }
    }
    ,
    onSubmit1(content){           

        click_handler(
        "详情页-预约购买",
        () => {
            this.$dialog.alert({message:"芒果TV全屏月卡将充入当前已登录账户，手机号仅用于接收预约信息",confirmButtonText:"OK"}).then(()=>{
                let order_params ={}
                order_params.productId = this.product.id
                order_params.ticket =  this.ticket   
                order_params.phone = this.phone
                order_params.receiverName =  ""  
                order_params.address =  ""  
                order_params.mac =  "qqq"    
                let code = this.$route.query.code;  
                orderAndPay(order_params,code,this.pay_success,this);
                
            }).catch(() => {
                  console.log('alert catch')
            });
        },
        {
          need_login: true,
          need_act: true
        },
        this);
    }
    ,
    onSubmit2(){     
        let T = this
        click_handler(
        "详情页-购买",
        () => {
            this.$router.push({
                path: `/AddressConfirm`,
                query: this.$route.query
            })
        },
        {
          need_login: true,
          need_act: true
        },
        this);
    }
    ,
    onClick2(){
        alert("")
    }
    ,
    toggle(index) {
      let isItemChecked = this.$refs.vouchers[index].checked
      if(!isItemChecked)
        this.$refs.vouchers[index].checked = true
    //   else
    //     this.$refs.vouchers[index].checked = false
    },
    clickCk(a){
        console.log("sdfsdf")
    }
  }
}
</script>
<style lang="stylus">
    @import "../share/mixins.styl"

    .product    
        height 14rem
        padding-top 0.22rem
        padding-bottom 1.1rem
        font-font-family PingFangSC-Medium
        background-color #5960F9 
        .productImage 
            width 6.9rem
            height 6.9rem
            border-radius 0.1rem
            margin 0 auto
            background-color white
            img
                width 6.9rem
                height 6.9rem
                
        .productInfoPanel
            background-color #5960F9 
            .van-panel__header
                background-color #5960F9 
            .van-cell:not(:last-child)::after
                border none
            .van-cell__title  
                padding-left 0.18rem             
                span
                    line-height 0.9rem
                    display block
                    color #FFB400
                    font-size 0.64rem
                    &:first-letter                    
                        font-size 0.36rem
                        margin-right 0.1rem
            .van-cell__label
                line-height 0.5rem
                color #ffffff
                font-size 0.36rem    
            .van-panel__footer
                padding 0
            .van-panel__content
                padding 0.1rem 0.25rem
                .productDesc
                    background-color rgba(255,255,255,0.1)               
                    border-radius: 0.1rem
                    padding: 0.18rem
                    .van-row
                        padding 0.1rem 0
                    .van-col
                        line-height 0.37rem
                        color #ffffff
                        opacity 0.7
                        font-size 0.26rem    
        
            .van-hairline--top::after,.van-hairline::after
                border:none
                border-color white   
                        
        .van-hairline--top-bottom::after
            border:none
            border-color white
        .mobileInput
        input
            width 3.9rem
            height 0.9rem
            background-color #F4F4F4
            
            border-radius 1rem
            font-size 0.36rem
            padding 0 0.1rem
            color #131729
        
        .van-submit-bar 
            padding-top 0.1rem
            background-color #5960F9
            .van-submit-bar__price
                flex 0
            .van-submit-bar_left
                flex 1
            .van-submit-bar__bar
                background-color #5960F9
                flex 1
                height 1rem
                text-align center
                font-size 0.36rem
                .buyPrice
                    font-size 0.48rem
                    color #FD6A55
                .van-button
                    line-height 0.9rem
                    .van-button__text
                        font-size 0.36rem
                        line-height 0.9rem
        .order
            .van-button 
                width 2.6rem
                height 0.9rem
                border-radius 1rem
                background-color #FD6A55
                opacity 1
            .van-submit-bar__bar
                height 1.3rem
                padding 0 0.4rem
            .van-button--disabled
                color white
                opacity 0.4
        .voucherTitle
            margin-top 0.1rem
        .voucherListPanel
            background-color transparent
            .voucherList
                .van-panel__header
                    padding-top 0
                    padding-bottom 0
                    .van-cell__title
                        font-size 0.2rem
                .van-hairline::after
                    border:none
                    border-color white 
                .van-cell-group
                    .van-cell__title
                        flex: 5;
                        .vName
                            color white
                            font-size 0.3rem
                            margin-left 0.18rem
                        .vStatus
                            margin-left 2em
                            color #aaa
                        .vPrice
                            margin-left 1em
                            color #FD6A55
                    .van-cell__value
                        flex: 1;
                        .van-checkbox--checked
                            border-color #FD6A55
                            background-color #FD6A55

            .van-panel__header,.van-panel__content,.van-cell-group,.van-cell
                background-color transparent
            .van-hairline--top-bottom::after,.van-hairline--top::after,van-cell:not(:last-child)::after
                border:none
            .van-panel__header
                display none
        .go
            padding-bottom 0.4rem
            background-color transparent
            .van-submit-bar__bar
                border-radius 0.9rem            
                width 6.9rem
                height 0.9rem
                line-height 0.5rem
               
                margin 0 auto
                display flex
                align-items center
                .van-submit-bar_left
                    display flex
                    align-items center
                .buyLabel,.buyPrice
                    flex 1
                    line-height 0.5rem
                .buyLabel
                    text-align right 
                    font-size 0.26rem
                .buyPrice
                    text-align left

        .go
            .van-submit-bar__bar
                background-color white
                .van-button
                    border-radius 0 0.9rem 0.9rem 0
        .order
            .mobileInput
                width 4rem
                height 0.9rem
                background-color #F4F4F4
                
                border-radius 1rem
                font-size 0.36rem
                padding 0 0.1rem
                color #131729
        .icon_sit
            position absolute
            width 1.63rem
            height 1.23rem
            right 0.57rem
            top 7.46rem
        .goButtonContainer 
            left: 0;
            bottom: 0;
            width: 100%;
            z-index: 100;
            position: fixed;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;    
            padding 0.1rem 0.3rem 0.3rem 0.4rem       
            .goButton
                .van-submit-bar
                    position relative
                    padding 0
</style>
<style>
.voucherListPanel   [class*=van-hairline]:after{
            border:none
        }
.van-dialog__confirm, .van-dialog__confirm:active{
        color: #007AFF;
}
.van-dialog__message{
    color:#030303;
    font-size:0.32rem;
    text-align: center
}
[class*=van-hairline]::after {
    border-color: rgba(77,77,77,0.4);

}
.van-dialog .van-button{
    font-size:0.32rem;
    line-height: 0.48rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderDetail.vue